const DEFAULT_MIN_DELAY_MS = 4000;

function initSpamGuard(form) {
  if (!(form instanceof HTMLFormElement) || form.dataset.spamGuardInitialized === 'true') {
    return;
  }

  form.dataset.spamGuardInitialized = 'true';

  const minDelayMs = Number.parseInt(form.dataset.spamGuardMinDelay || '', 10) || DEFAULT_MIN_DELAY_MS;
  const messageNode = form.querySelector('[data-spam-guard-message]');
  const honeypot = form.querySelector('[data-spam-guard-honeypot]');
  const namedFields = Array.from(form.querySelectorAll('[data-spam-guard-name]'));
  const submitButtons = Array.from(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
  const state = {
    loadedAt: Date.now(),
    interacted: false,
    armed: false,
  };

  namedFields.forEach((field) => {
    const name = field.getAttribute('data-spam-guard-name');
    if (name) {
      field.setAttribute('name', name);
    }
  });

  function setMessage(text) {
    if (!messageNode) return;
    messageNode.textContent = text;
    messageNode.hidden = !text;
  }

  function syncButtons() {
    const ready = state.interacted && Date.now() - state.loadedAt >= minDelayMs;
    state.armed = ready;

    submitButtons.forEach((button) => {
      button.disabled = !ready;
      if (!ready) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
    });
  }

  function registerInteraction() {
    if (!state.interacted) {
      state.interacted = true;
      syncButtons();
    }
  }

  form.addEventListener('focusin', registerInteraction, { passive: true });
  form.addEventListener('pointerdown', registerInteraction, { passive: true });
  form.addEventListener('keydown', registerInteraction);
  form.addEventListener('input', registerInteraction);

  window.setTimeout(syncButtons, minDelayMs);
  syncButtons();

  form.addEventListener('submit', (event) => {
    const tooFast = Date.now() - state.loadedAt < minDelayMs;
    const botTriggered = Boolean(honeypot && honeypot.value.trim());

    if (botTriggered) {
      event.preventDefault();
      setMessage(form.dataset.spamGuardBlockedMessage || '');
      return;
    }

    if (!state.interacted || tooFast || !state.armed) {
      event.preventDefault();
      setMessage(form.dataset.spamGuardTooFastMessage || '');
      syncButtons();
      return;
    }

    setMessage('');
  });
}

function initAllSpamGuards(root = document) {
  root.querySelectorAll('[data-spam-guard-form="true"]').forEach((target) => {
    const form = target instanceof HTMLFormElement ? target : target.querySelector('form');
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    if (target instanceof HTMLElement) {
      if (target.dataset.spamGuardMinDelay && !form.dataset.spamGuardMinDelay) {
        form.dataset.spamGuardMinDelay = target.dataset.spamGuardMinDelay;
      }

      if (target.dataset.spamGuardTooFastMessage && !form.dataset.spamGuardTooFastMessage) {
        form.dataset.spamGuardTooFastMessage = target.dataset.spamGuardTooFastMessage;
      }

      if (target.dataset.spamGuardBlockedMessage && !form.dataset.spamGuardBlockedMessage) {
        form.dataset.spamGuardBlockedMessage = target.dataset.spamGuardBlockedMessage;
      }
    }

    initSpamGuard(form);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllSpamGuards(), { once: true });
} else {
  initAllSpamGuards();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllSpamGuards(event.target instanceof Element ? event.target : document);
});
